import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { PartnerAnalysisGroup5 } from 'src/app/assabil-kernel/models/entities/control-tables/partner-analysis-group5';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PartnerAnalysisGroup5Request } from 'src/app/assabil-kernel/models/dtos/control-tables/partner-analysis-group5-request';


@Component({
  selector: 'app-partner-analysis-group5-list',
  templateUrl: './partner-analysis-group5-list.component.html',
  styleUrls: ['./partner-analysis-group5-list.component.scss']
})
export class PartnerAnalysisGroup5ListComponent  extends BasePage2<PartnerAnalysisGroup5> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  partnersAnalysisGroups: PartnerAnalysisGroup5[] = [];
  // ---------------------------------------------------
  

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = 'partnerAnalysisGroup5';
  }


  listFields = [
      { prop: 'partnerAnalysisGroup5Code', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },
      { prop: 'rank', name: 'Rang' }
  ]

  getRows(): PartnerAnalysisGroup5[] {
      return this.partnersAnalysisGroups;
  }

//----------------------------------------------------------------------
saveRow(partnerAnalysisGroup5: PartnerAnalysisGroup5): Promise<PartnerAnalysisGroup5> {
  let request  : PartnerAnalysisGroup5Request = new PartnerAnalysisGroup5Request(this.controlService.getUserInfo());
  request.partnerAnalysisGroup5 = partnerAnalysisGroup5;
    return this.controlService.save(this.entityName, request);
}
//----------------------------------------------------------------------

  //----------------------------------------------------------------------
  new(){
    let entity : PartnerAnalysisGroup5 = new PartnerAnalysisGroup5();
    entity.inserted = true;
    entity.edit = true;
    this.partnersAnalysisGroups.push(entity);
    this.partnersAnalysisGroups = [...this.partnersAnalysisGroups];
    }
//----------------------------------------------------------------------

  loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.partnersAnalysisGroups = result;
        
    }).catch(error => {
        this.showError(error);
    })
  }

  }
